import React, { useState, useEffect, useContext } from "react";
import "./styles.css";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import SVG from "../svg/Svg";
import UploadForm from "../upload/Upload";
import ButtonComponent from "../buttons/ButtonComponent";
// `Н48.1` (`АУД-Н174`): причина отказа сервера видна человеку, форма не закрывается.
import { errorMessageFrom } from "../../utils/serverFieldErrors";

interface UserProps {
  role?: string;
  photo?: string;
  fullName?: string;
  organization?: string;
  phone?: string;
  email?: string;
  updatePhoto?: () => void;
  openUser?: () => void;
}

const User: React.FC<UserProps> = ({
  role,
  photo,
  fullName,
  organization,
  phone,
  email,
  updatePhoto,
  openUser,
}) => {
  const { store } = useContext(Context);
  const [isActive, setActive] = useState(false);
  const [userPhone, setUserPhone] = useState(phone || "");
  const [imgError, setImgError] = useState(false);
  // `Н48.1`: отказ правки своей записи — текстом, а не закрытием формы.
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setUserPhone(phone || "");
  }, [phone]);

  useEffect(() => {
    setImgError(false);
  }, [photo]);

  const displayName = fullName?.trim() || email || "Пользователь";
  const displayOrg = organization?.trim() || "";

  const toggleUpload = () => setActive((prev) => !prev);

  const handlePhotoUpdate = () => {
    setActive(false);
    updatePhoto?.();
  };

  const handleSave = async () => {
    setError(null);

    try {
      // АДРЕС.1 (`АРХ-Н43`): адрес меняет только администратор — его не шлём.
      await store.editUser({ tel: userPhone });
      openUser?.();
    } catch (err) {
      // `Н48.1`: форма остаётся открытой, причина — на экране.
      setError(errorMessageFrom(err, "Ошибка при сохранении"));
    }
  };
  console.log(photo, "user foto sring");
  return (
    <div className="user-card">
      <div className="user-header">
        <div
          className="circle-gradient"
          onClick={toggleUpload}
          title="Изменить фото"
        >
          {!imgError ? (
            <img
              src={photo}
              alt={displayName}
              className="user-photo"
              onLoad={() => setImgError(false)}
              onError={() => setImgError(true)}
            />
          ) : (
            <span className="user-photo-placeholder">
              {SVG["defaultAvaCircle"]}
            </span>
          )}
        </div>
        <div className="user-title-info">
          <div className="user-role">{role || "Пользователь"}</div>
          <div className="user-name">{displayName}</div>
          <div className="user-organization">{displayOrg}</div>
        </div>
      </div>
      {isActive && (
        <div className="user-upload-wrap">
          <UploadForm activLoad={handlePhotoUpdate} />
        </div>
      )}
      <div className="user-info">
        <div className="user-contact-row">
          <span className="user-contact-icon">{SVG["phone"]}</span>
          <span className="user-contact-label">Телефон</span>
          <input
            type="text"
            value={userPhone}
            onChange={(e) => setUserPhone(e.target.value)}
            className="editable-input"
            placeholder="Не указан"
          />
        </div>
        <div className="user-contact-row">
          <span className="user-contact-icon">{SVG["dog"]}</span>
          <span className="user-contact-label">Email</span>
          {/* АДРЕС.1: адрес — только чтение, меняет администратор. */}
          <input
            type="email"
            value={email || ""}
            readOnly
            aria-describedby="user-email-hint"
            className="editable-input"
            placeholder="Не указан"
          />
        </div>
        <div id="user-email-hint" className="user-contact-hint">
          адрес меняется через администратора
        </div>
      </div>
      {error && (
        <div className="Error_message" data-user-save-error>
          {error}
        </div>
      )}
      <div className="user-actions">
        <ButtonComponent onClick={handleSave} title="Сохранить" size="100%" />
      </div>
    </div>
  );
};

export default observer(User);
